import React from "react";
import { BrandingForm as BrandingFormDefinition } from "./BrandingForm";

export const BrandingForm = React.memo(BrandingFormDefinition);
